@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../constants/spacing.module.less';
@import '../../constants/screen-width-breakpoints.module.less';

.rate-viewer {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.rate-viewer-body {
  background: @rate-viewer--body--background-color;
  height: calc(100% - 50px);
  max-height: calc(100% - 50px);
  overflow: auto;
  position: relative;
}

.loading-indicator {
  height: 300px;
  padding: 15px;
}

.empty-content {
  padding: 15px;
  min-height: 300px;
  position: relative;
  width: 100%;
}

.empty-message {
  margin: 55px auto;
  color: @rate-viewer--empty-message--text-color;
  max-width: 250px;
  text-align: center;
  font-size: 14px;
}

.rate-viewer-footer {
  border-top: 1px solid @rate-viewer--footer--border-color;
  height: 50px;
  padding: 10px;
  text-align: right;
  background-color: @rate-browser-modal-form--footer--background-color;
  flex-shrink: 0;

  @media @mobile, @ultramobile {
    position: sticky;
    bottom: 0;
  }
}

.configure-label-button {
  .configure-label-button-text {
    vertical-align: top;
    display: inline-block;
  }
}

.configure-label-icon {
  height: 30px;
  width: 30px;
  margin-right: -10px;
  padding: 9px;
}

.normal-content {
  display: flex;
  align-items: stretch;
  height: 100%;
  position: relative;
}

.seller-provider-list {
  width: 206px;
  min-width: 206px;
  max-height: 100%;
  overflow: auto;
  border-right: 1px solid @rate-viewer--seller-provider-list--border-color;
  position: relative;
  z-index: 2;
}

.rate-list {
  width: calc(100% - 206px);
  position: relative;
  z-index: 1;
}

.wallet-activation-button {
  margin-top: @space-12;
}

.upgrade-plan-promotional-banner {
  margin: @space-16;
}
